export default {"src":"/_next/static/media/brocswap.e6c0ce7c.svg","height":250,"width":1500,"blurWidth":0,"blurHeight":0};